var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 70,
    viewBox: "0 0 45 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51111 5.59766L0 45.9506H13.4849L4.51111 5.59766Z",
    fill: "url(#paint0_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51119 5.59766L2.94434 45.9506H17.7582L4.51119 5.59766Z",
    fill: "url(#paint1_radial_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51172 5.59766L9.78204 45.9506H17.7587",
    fill: "url(#paint2_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1132 25.8447L44.1103 47.6791H28.7979L43.1132 25.8447Z",
    fill: "url(#paint3_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1127 25.8447L44.8932 47.8554L38.4834 47.6791L43.1127 25.8447Z",
    fill: "url(#paint4_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4589 0L42.5901 45.9502H13.2002L22.4589 0Z",
    fill: "#F9BE24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4589 0L32.9041 45.9502H21.3193L22.4589 0Z",
    fill: "url(#paint5_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3367 2.8457L9.06934 45.95H21.9603L15.3367 2.8457Z",
    fill: "url(#paint6_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3369 2.8457L20.1799 45.95H26.2337L15.3369 2.8457Z",
    fill: "url(#paint7_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3369 2.8457L24.8805 45.95H31.6464L15.3369 2.8457Z",
    fill: "url(#paint8_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3369 2.8457L29.7235 45.95H35.065L15.3369 2.8457Z",
    fill: "url(#paint9_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6596 18.8451L17.0631 18.2158L11.3655 30.1538L9.06934 45.9507H35.0648L22.6596 18.8451Z",
    fill: "url(#paint10_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5508 24.3987L31.7435 29.5021L45.0005 1.71777L15.5508 24.3987Z",
    fill: "url(#paint11_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7793 28.5807L37.4867 31.277L45.0005 1.71777L28.7793 28.5807Z",
    fill: "url(#paint12_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5508 24.3985L37.4867 31.2769L32.5369 22.3174L15.5508 24.3985Z",
    fill: "url(#paint13_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 45.95L15.5503 66.4087L37.7711 63.2341L44.8932 47.8548L36.0618 32.6871L16.9747 27.2197L0 45.95Z",
    fill: "url(#paint14_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 45.9512L14.1259 69.2317L37.7711 63.2352L0 45.9512Z",
    fill: "url(#paint15_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 45.9506L44.8932 47.8554L36.0618 32.6877L15.5503 24.3984L0 45.9506Z",
    fill: "url(#paint16_linear_33_74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8936 47.8554L37.4867 31.2768L15.5508 24.3984L44.8936 47.8554Z",
    fill: "url(#paint17_linear_33_74)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_74",
    x1: 11.2585,
    y1: 7.67174,
    x2: 6.24252,
    y2: 48.6078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFDE14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#77C53D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_33_74",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.03252 29.1604) scale(10.4993 10.4001)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9BD421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFDE14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_74",
    x1: 7.78929,
    y1: 7.54617,
    x2: 13.5947,
    y2: 45.5383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#77C53D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#AFDE14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33_74",
    x1: 48.0944,
    y1: 29.3058,
    x2: 41.2544,
    y2: 40.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#862149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#531D3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_33_74",
    x1: 45.0699,
    y1: 27.322,
    x2: 41.8902,
    y2: 46.9099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#821D47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#851F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#30232A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_33_74",
    x1: 23.8092,
    y1: 3.3524,
    x2: 25.0225,
    y2: 19.3063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C128"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_33_74",
    x1: 19.8322,
    y1: 3.51167,
    x2: 17.488,
    y2: 26.9857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CA5F0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C02708"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_33_74",
    x1: 18.2883,
    y1: 4.13248,
    x2: 20.1518,
    y2: 20.2862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#DA6A05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C51A10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_33_74",
    x1: 17.9279,
    y1: 2.90073,
    x2: 21.8158,
    y2: 19.4028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#C51A10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_33_74",
    x1: 16.0634,
    y1: 2.89791,
    x2: 23.4193,
    y2: 22.6619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFCD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4080D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_33_74",
    x1: 26.846,
    y1: 20.2377,
    x2: 24.8585,
    y2: 30.1724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C11B0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C24103"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_33_74",
    x1: 43.2314,
    y1: 11.3785,
    x2: 22.8531,
    y2: 27.8921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D04214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_33_74",
    x1: 48.2866,
    y1: 5.37917,
    x2: 33.8003,
    y2: 28.6835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE0A0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_33_74",
    x1: 35.296,
    y1: 26.8761,
    x2: 21.2995,
    y2: 22.8985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C20710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2090E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_33_74",
    x1: 5.96259,
    y1: 40.8128,
    x2: 40.8585,
    y2: 56.4691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#39282E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F2643"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_33_74",
    x1: 6.93831,
    y1: 54.8514,
    x2: 35.0288,
    y2: 71.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2F2025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F2643"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_33_74",
    x1: 9.05783,
    y1: 35.631,
    x2: 40.9674,
    y2: 47.2003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#46323B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#752F4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_33_74",
    x1: 19.6203,
    y1: 22.0549,
    x2: 45.9068,
    y2: 44.5136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#654353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#60454E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F3F64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 69.2308,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBg);
export default __webpack_public_path__ + "static/media/logo_bg.9bd0ac2d44a46cd858fdf3478b34700b.svg";
export { ForwardRef as ReactComponent };